import * as React from 'react';
import { useParams } from 'react-router';
import {
  Box, Table, TableBody, TableCell, TableFooter,
  TableHead, TableRow, CircularProgress
} from '@mui/material';
import { useFetchTeamsQuery } from '../../store/team/TeamApi';
import { myConstants } from '../../shares/Constants';

export default function MealAdmin() 
{
  const { year } = useParams();
  const { data: teams, isLoading } = useFetchTeamsQuery({ year, clubLabel: '' });

  if (isLoading) 
  {
    return <CircularProgress />
  };

  /*
   * Auf die Teams filter, die hier auch wirklich
   * relevant sind (keine zurückgezogenen oder auf der Warteliste stehenden) 
  */
 const registeredTeams = 
  (teams ?? []).filter(
    team => (team.status ?? myConstants.teamModel.status.registered) === myConstants.teamModel.status.registered
  );

  /*
   * Aufteilung der Teams nach Clubs
   */
  const byClub = (registeredTeams ?? []).reduce(
    (acc, team) => 
      {
        if (!acc[team.clubLabel]) acc[team.clubLabel] = [];
        acc[team.clubLabel].push(team);
        return acc;
      }, {}
  );

  // Summenfunktion für beliebige Felder aus der Übersicht (einmal über alle Teams)
  const sum = (field) => (registeredTeams ?? []).reduce((s, t) => s + (t[field] ?? 0), 0);

  return (
    <Box>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Verein</TableCell>
            <TableCell>Team</TableCell>
            {/* <TableCell align="right">Abendessen Fr.</TableCell> */}
            <TableCell align="right">Frühstück Sa.</TableCell>
            <TableCell align="right">Abendessen Sa.</TableCell>
            <TableCell align="right">Frühstück So.</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Object.entries(byClub).map(([clubLabel, clubTeams]) => {
            const clubSum = (field) => clubTeams.reduce((s, t) => s + (t[field] ?? 0), 0);
            return (
              <React.Fragment key={clubLabel}>
                {clubTeams.map(team => (
                  <TableRow key={`${team.label}_${team.counter}`}>
                    <TableCell>{clubLabel}</TableCell>
                    <TableCell>{team.label} ({team.counter})</TableCell>
                    {/* <TableCell align="right">{team.fridayLunch}</TableCell> */}
                    <TableCell align="right">{team.saturdayBreakfast}</TableCell>
                    <TableCell align="right">{team.saturdayLunch}</TableCell>
                    <TableCell align="right">{team.sundayBreakfast}</TableCell>
                  </TableRow>
                ))}
                <TableRow sx={{ backgroundColor: 'action.hover' }}>
                  <TableCell colSpan={2}><strong>{clubLabel} – Summe</strong></TableCell>
                  {/* <TableCell align="right"><strong>{clubSum('fridayLunch')}</strong></TableCell> */}
                  <TableCell align="right"><strong>{clubSum('saturdayBreakfast')}</strong></TableCell>
                  <TableCell align="right"><strong>{clubSum('saturdayLunch')}</strong></TableCell>
                  <TableCell align="right"><strong>{clubSum('sundayBreakfast')}</strong></TableCell>
                </TableRow>
              </React.Fragment>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow sx={{ backgroundColor: 'primary.light' }}>
            <TableCell colSpan={2}><strong>Gesamtsumme</strong></TableCell>
            {/* <TableCell align="right"><strong>{sum('fridayLunch')}</strong></TableCell> */}
            <TableCell align="right"><strong>{sum('saturdayBreakfast')}</strong></TableCell>
            <TableCell align="right"><strong>{sum('saturdayLunch')}</strong></TableCell>
            <TableCell align="right"><strong>{sum('sundayBreakfast')}</strong></TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </Box>
  );
}
